"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = videoInputDevice;
var _types = require("../../actions/meeting/types");
function videoInputDevice() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_SET_VIDEO_DEVICE) {
    return action.payload;
  }
  return state;
}